import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BranchService from "../../services/BranchesService";
import LoyaltyProgramService from "../../services/LoyaltyProgram";
import { toast } from "react-toastify";

export const createRewardPointConfig = createAsyncThunk(
  "loyaltyprogram/createRewardPointConfig",
  async (data, thunkAPI) => {
    try {
      const res = await LoyaltyProgramService.addRewardPointConfigurations(
        data
      );

      if (res.status == 1) {
        toast.success(res.message);
        return res;
      } else {
        toast.warning(res.message);
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCustomerRedeemOffer = createAsyncThunk(
  "loyaltyprogram/fetchCustomerRedeemOffer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await LoyaltyProgramService.getCustomerRedeemOffers(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  rewardPointConfig: null,
  customerRedeemOffer: [],
  total_pages: 0,
  total_records: 0,
};

const loyaltyProgramSlice = createSlice({
  name: "loyaltyprogram",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // ADD REWAD POINTS CONFIGURATIONS

    builder
      .addCase(createRewardPointConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRewardPointConfig.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.rewardPointConfig = payload;
      })
      .addCase(createRewardPointConfig.rejected, (state) => {
        state.loading = false;
      });

    //GET CUSTOMER REDEEM OFFERS

    builder
      .addCase(fetchCustomerRedeemOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerRedeemOffer.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.customerRedeemOffer = payload?.data;
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchCustomerRedeemOffer.rejected, (state) => {
        state.loading = false;
        state.customerRedeemOffer = [];
        state.total_pages = 0;
        state.total_records = 0;
      });
  },
});

export default loyaltyProgramSlice.reducer;
